//import { TestimonialSlider } from '../../../js/src/__utils/sliders';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		//TestimonialSlider.init();
		const settings = {
			dots: true,
			arrows: false,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			adaptiveHeight: true,
			speed: 600,
			customPaging(slider, i) {
				const thumb = jQuery(slider.$slides[i].innerHTML)
					.find('div[data-thumb]')
					.data('thumb');
				if (thumb) {
					return '<img src=' + thumb + ' />';
				}
			},
		};
		jQuery('.testimonial-slider').slick(settings);
	},
	loaded() {
		jQuery('.testimonial-slider__logo[data-slide-id="0"]').addClass(
			'active'
		);
		jQuery('body').on(
			'click',
			'.testimonial-slider__logo img',
			function (event) {
				event.preventDefault();
				const clickedId = jQuery(this).closest('li').data('slide-id');
				const goToSlide = jQuery(
					'.testimonial-slider__slide[data-slide-id="' +
						clickedId +
						'"]'
				).data('slick-index');
				jQuery('.testimonial-slider').slick('slickGoTo', goToSlide);
				jQuery('.testimonial-slider__logo').removeClass('active');
				jQuery(
					'.testimonial-slider__logo[data-slide-id=' + clickedId + ']'
				).addClass('active');
			}
		);
	},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
